import React from 'react';
import packageJson from '../../../package.json';
import { LDOptions, LDProvider } from 'launchdarkly-react-client-sdk';

type Props = {
    children: React.ReactNode;
};

export const FeatureFlagsProvider: React.FC<Props> = ({ children }) => {
    const ldOptions: LDOptions = {
        // bootstrap: 'localStorage',

        application: {
            id: 'quality-by-foundations',
            version: `${packageJson.version}`,
        },
    } as const;

    return (
        <LDProvider
            clientSideID={process.env.LAUNCH_DARKLY_CLIENT_ID}
            options={ldOptions}
        >
            {children}
        </LDProvider>
    );
};

export default FeatureFlagsProvider;
